import { Alert, Avatar, Badge, Box, Button, Card, Checkbox, CircularProgress, Drawer, FormControl, IconButton, InputAdornment, InputBase, InputLabel, LinearProgress, ListItemIcon, Menu, MenuItem, OutlinedInput, Paper, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { ShoppingCartCheckout, Pix, Payments, CreditCard, WifiOff, SyncProblem, SmartToy } from "@mui/icons-material";
import { MetodoPagamento } from "../../../../core/enum/MetodoPagamento";
import { CaixaBusca, CardActionAreaChat, CardChat, CardChatMensagemContainer, ChatsContainer, DadosContatoContainer, MensagensContainer, MensagensContatoContainer, MensagensHeaderContainer, PageContainer, PesquisarContainer, SessaoMensagensContainer } from "./styles";
import { ESTADO_ATENDIMENTO, cores, estadoDaConversa, limitarLinhas, precisaResponder, pulsoAtencao, raio, superficie, texto, textoAlerta, textoAlertaForte } from "../../../components/atendimento/identidade";
import { alpha } from "@mui/material/styles";
import { Search, KeyboardArrowDown, Delete, PersonAddAlt1, Close } from "@mui/icons-material";
import FullScreenLoading from "../../../../core/components/FullScreenLoading";
import { useMensagens } from "../../../hooks/atendimento/useMensagens";
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useDebounce } from "../../../../core/hooks/useDebounce";
import { useSearchParams } from "react-router-dom";
import { IChatMensagens } from "../../../interface/atendimento/IChatMensagens";
import { useDataHora } from "../../../../core/hooks/useDataHora";
import { ISessaoMensagens } from "../../../interface/atendimento/ISessaoMensagens";
import ChatBubble from "../../../components/atendimento/ChatBubble";
import AudioBubble from "../../../components/atendimento/AudioBubble";
import ImagemBubble from "../../../components/atendimento/ImagemBubble";
import VideoBubble from "../../../components/atendimento/VideoBubble";
import { TipoEmissorMensagem } from "../../../enum/atendimento/TipoEmissorMensagem.enum";
import { useThemeContext } from "../../../../core/contexts/ThemeContext";
import MessageInput from "../../../components/atendimento/MessageInput";
import { useWebSocketAtendimento } from "../../../hooks/atendimento/useWebSocketAtendimento";
import { IWebSocketNovaMensagemRecebida } from "../../../interface/atendimento/websocket/IWebSocketNovaMensagemRecebida";
import { IWebSocketNovaMensagemEnviada } from "../../../interface/atendimento/websocket/IWebSocketNovaMensagemEnviada";
import { IWebSocketNovaMensagem } from "../../../interface/atendimento/websocket/IWebSocketNovaMensagem";
import { IMensagem, IMensagemRespondida } from "../../../interface/atendimento/IMensagem";
import { ChatPdVProvider, useChatPdVContext } from "../../../contexts/atendimento/ChatPdVContext";
import { ChatPdVSidebar } from "../../../components/atendimento/ChatPdVSidebar";
import { StatusPedidosCores } from "../../../enum/StatusPedido";
import { useFetchMarketplaces } from "../../../../marketplace/hooks/useFetchMarketplaces";
import { IIntegracaoWhatsApp } from "../../../../marketplace/interfaces/IIntegracaoMarketplace";
import { useSingleTabChat } from "../../../hooks/atendimento/useSingleTabChat";
import { ChatAbaUnicaOverlay } from "../../../components/atendimento/ChatAbaUnicaOverlay";
import { useWebSocketAtendimentoContext } from "../../../contexts/atendimento/WebSocketAtendimentoContext";
import { AbasOperadores } from "../../../components/atendimento/AbasOperadores";
import { BarraAtribuicaoChat } from "../../../components/atendimento/BarraAtribuicaoChat";

const ConversasAtendimentoContent = () => {
    const { listarChats, buscarChatPorUuid, listarSessoes, removerAlerta, deletarChat, enviarMensagem, marcarChatComoLido, loadingAlerta, loadingEnvio } = useMensagens();
    const {
        isConnected,
        isConnecting,
        reconnectionAttempt,
        entrarChat,
        sairChat,
        enviarMensagemWhatsApp,
        onNovaMensagemRecebida,
        onNovaMensagemEnviada,
        onNovaMensagem,
        onChatLido,
        onAlertaChat,
        onAlertaChatRemovido,
        onStatusPedidoChat,
        onStatusMensagem,
        onMensagemEditada,
    } = useWebSocketAtendimento();
    const {
        socket,
        foiSubstituido,
        assumirSessao,
        operadores,
        atribuicoes,
        operadorUuidAtual,
        assumirChat,
        liberarChat,
        registrarAtendimento,
        liberarAtendimento,
    } = useWebSocketAtendimentoContext();
    const { chatBloqueado, motivo: motivoBloqueio, assumirControle: assumirControleAba } = useSingleTabChat();

    const estaBloqueado = chatBloqueado || foiSubstituido;
    const motivoExibir = foiSubstituido ? 'assumida-por-outra' : motivoBloqueio;
    const handleAssumirControle = foiSubstituido ? assumirSessao : assumirControleAba;
    const { definirContatoChat, loadingPedidosEmAndamento, pedidosEmAndamento, exibirNovoPedido, loadingCliente } = useChatPdVContext();

    const { marketplaces } = useFetchMarketplaces();

    const LIMITE_POR_PAGINA = 30;
    const [chats, setChats] = useState<IChatMensagens[]>([]);
    const [pesquisa, setPesquisa] = useState('');
    const pesquisaDebounced = useDebounce(pesquisa, 300);
    const pesquisaDebouncedRef = useRef(pesquisaDebounced);
    useEffect(() => { pesquisaDebouncedRef.current = pesquisaDebounced; }, [pesquisaDebounced]);

    const [pagina, setPagina] = useState(1);
    const [temMaisChats, setTemMaisChats] = useState(true);
    const [carregandoMais, setCarregandoMais] = useState(false);
    const sentinelRef = useRef<HTMLDivElement>(null);
    const chatsContainerRef = useRef<HTMLDivElement>(null);
    const [sessoes, setSessoes] = useState<ISessaoMensagens[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const chatSelecionado = searchParams.get('chat') || undefined;
    const [chatSelecionadoAnterior, setChatSelecionadoAnterior] = useState<string | undefined>(undefined);
    const [menuAnchorEl, setMenuAnchorEl] = useState<{element: HTMLElement, chatUuid: string} | null>(null);
    const [hoveredChat, setHoveredChat] = useState<string | null>(null);
    const [loadingExclusao, setLoadingExclusao] = useState(false);
    const [loadingChats, setLoadingChats] = useState(false);
    const [modoSelecao, setModoSelecao] = useState(false);
    const [chatsSelecionados, setChatsSelecionados] = useState<Set<string>>(new Set());
    const [abaAtiva, setAbaAtiva] = useState<string>('TODOS');
    const [drawerCheckoutAberto, setDrawerCheckoutAberto] = useState(false);
    const [mensagemParaResponder, setMensagemParaResponderState] = useState<IMensagemRespondida | null>(null);
    // Ref espelha o state para garantir leitura do valor mais atual em closures async
    const mensagemParaResponderRef = useRef<IMensagemRespondida | null>(null);

    const setMensagemParaResponder = (value: IMensagemRespondida | null) => {
        mensagemParaResponderRef.current = value;
        setMensagemParaResponderState(value);
    };
    const { dataHoraBr, dataHoraOuHora } = useDataHora();
    const { themeName } = useThemeContext();

    // Se a tela for menor que 1200px, o checkout vira drawer
    const checkoutComoDrawer = useMediaQuery('(max-width: 1200px)');

    // Refs para manter valores atuais sem causar re-renders nos listeners
    const chatSelecionadoRef = useRef<string | undefined>(undefined);
    const chatMarcadoComoLidoRef = useRef<string | undefined>(undefined);
    const chatProcessadoRef = useRef<string | undefined>(undefined);
    const marcarLidoDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    
    // State para trigger de refresh de sessões (usar state garante re-render)
    const [sessoesRefreshTrigger, setSessoesRefreshTrigger] = useState(0);

    // Esta aba vale como operador (presença e atribuição de conversas) apenas
    // enquanto a tela está aberta e não bloqueada por outra aba. A conexão em si
    // continua viva — é ela que mantém o badge de não lidas do menu atualizado.
    useEffect(() => {
        if (chatBloqueado) {
            liberarAtendimento();
            return;
        }

        registrarAtendimento();

        return () => liberarAtendimento();
    }, [chatBloqueado, registrarAtendimento, liberarAtendimento]);

    // Manter ref sincronizada com o state
    useEffect(() => {
        chatSelecionadoRef.current = chatSelecionado;
        // Limpar ref de processamento quando o chat mudar
        if (chatProcessadoRef.current !== chatSelecionado) {
            chatProcessadoRef.current = undefined;
        }
    }, [chatSelecionado]);

    const handleRemoverAlerta = async (uuid: string) => {
        await removerAlerta(uuid);
        handleListarChats();
    }

    const handleListarChats = async (paginaAlvo = 1, append = false) => {
        if (paginaAlvo === 1 && !append) {
            setLoadingChats(true);
        } else {
            setCarregandoMais(true);
        }
        try {
            const buscaAtual = pesquisaDebouncedRef.current.trim() || undefined;
            const chatsEncontrados: IChatMensagens[] | null = await listarChats(paginaAlvo, LIMITE_POR_PAGINA, buscaAtual);
            // null significa que já há uma chamada em andamento — ignorar para não limpar o chat selecionado
            if (chatsEncontrados === null) {
                return;
            }
            const lista = chatsEncontrados ?? [];
            setTemMaisChats(lista.length === LIMITE_POR_PAGINA);
            setPagina(paginaAlvo);
            if (append) {
                setChats(prev => {
                    const vistos = new Set(prev.map(c => c.uuid));
                    const novos = lista.filter(c => !vistos.has(c.uuid));
                    return [...prev, ...novos];
                });
            } else {
                setChats(lista);
                if (lista.length === 0 && !buscaAtual) {
                    setSearchParams(prev => {
                        prev.delete('chat');
                        return prev;
                    });
                    setSessoes([]);
                }
            }
        } finally {
            setLoadingChats(false);
            setCarregandoMais(false);
        }
    }

    const handleListarSessoes = async () => {
        if (!chatSelecionado) {
            return;
        }

        const sessoesEncontradas: ISessaoMensagens[] = await listarSessoes(chatSelecionado, 1, 10);
        setSessoes(sessoesEncontradas || []);
        mensagemParaResponderRef.current = null;
        setMensagemParaResponderState(null);
    }

    const handleChat = async (uuid: string) => {
        setSearchParams({ chat: uuid });
    }

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, chatUuid: string) => {
        event.stopPropagation();
        setMenuAnchorEl({ element: event.currentTarget, chatUuid });
    };

    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
        setHoveredChat(null);
    };

    const handleExcluirChat = async () => {
        if (!menuAnchorEl) return;
        
        const chatExcluidoUuid = menuAnchorEl.chatUuid;
        setLoadingExclusao(true);
        handleCloseMenu();
        
        // Se o chat excluído for o selecionado, limpa antes de recarregar
        if (chatSelecionado === chatExcluidoUuid) {
            setSearchParams(prev => {
                prev.delete('chat');
                return prev;
            });
            setSessoes([]);
        }
        
        const sucesso = await deletarChat(chatExcluidoUuid);
        if (sucesso) {
            await handleListarChats(); // Não auto-seleciona após exclusão
        }
        
        setLoadingExclusao(false);
    };

    const handleToggleModoSelecao = () => {
        setModoSelecao(prev => !prev);
        setChatsSelecionados(new Set());
    };

    const handleToggleChatSelecionado = (uuid: string) => {
        setChatsSelecionados(prev => {
            const novo = new Set(prev);
            if (novo.has(uuid)) {
                novo.delete(uuid);
            } else {
                novo.add(uuid);
            }
            return novo;
        });
    };

    const handleSelecionarTodos = () => {
        if (chatsSelecionados.size === chats.length) {
            setChatsSelecionados(new Set());
        } else {
            setChatsSelecionados(new Set(chats.map(c => c.uuid)));
        }
    };

    const handleExcluirSelecionados = async () => {
        if (chatsSelecionados.size === 0) return;

        setLoadingExclusao(true);

        if (chatSelecionado && chatsSelecionados.has(chatSelecionado)) {
            setSearchParams(prev => {
                prev.delete('chat');
                return prev;
            });
            setSessoes([]);
        }

        await Promise.all(Array.from(chatsSelecionados).map(uuid => deletarChat(uuid)));

        setChatsSelecionados(new Set());
        setModoSelecao(false);
        await handleListarChats();
        setLoadingExclusao(false);
    };

    // Assume o atendimento de vários chats de uma vez, sem precisar abri-los.
    // Emite 'assumir-chat' por chat (via socket); como não abrimos nenhum,
    // nenhum é marcado como lido — a triagem não interfere no contador de não-lidas.
    const handleAssumirSelecionados = () => {
        if (chatsSelecionados.size === 0 || !isConnected) return;

        chatsSelecionados.forEach(uuid => assumirChat(uuid));

        setChatsSelecionados(new Set());
        setModoSelecao(false);
    };

    const handleEnviarMensagem = async (mensagem: string) => {
        if (!chatSelecionado) return;

        const chatAtual = chats.find(c => c.uuid === chatSelecionado);
        if (!chatAtual || !chatAtual.contato?.telefone) return;

        // Lê do ref para garantir o valor mais atual (evita stale closure)
        const replyPayload = mensagemParaResponderRef.current ?? undefined;
        mensagemParaResponderRef.current = null;
        setMensagemParaResponderState(null);

        // Enviar via WebSocket se conectado, senão via HTTP
        if (isConnected) {
            const sucesso = enviarMensagemWhatsApp({
                chatUuid: chatSelecionado,
                telefone: chatAtual.contato.telefone,
                mensagem: mensagem,
                marketplaceUuid: chatAtual.marketplaceUuid,
                mensagemRespondida: replyPayload ? {
                    identificadorExterno: replyPayload.identificadorExterno,
                    texto: replyPayload.texto,
                    emissor: replyPayload.emissor as string | undefined,
                } : undefined
            });

            if (!sucesso) {
                // Fallback para HTTP se WebSocket falhar
                const mensagemEnviada = await enviarMensagem(chatSelecionado, mensagem, replyPayload ? {
                    identificadorExterno: replyPayload.identificadorExterno,
                    texto: replyPayload.texto,
                    emissor: replyPayload.emissor as string | undefined,
                } : undefined);
                if (mensagemEnviada) {
                    await handleListarSessoes();
                }
            }
            // Se sucesso via WebSocket, a mensagem será adicionada via evento
        } else {
            // Sem WebSocket, usar HTTP
            const mensagemEnviada = await enviarMensagem(chatSelecionado, mensagem, replyPayload ? {
                identificadorExterno: replyPayload.identificadorExterno,
                texto: replyPayload.texto,
                emissor: replyPayload.emissor as string | undefined,
            } : undefined);
            if (mensagemEnviada) {
                await handleListarSessoes();
            }
        }
    };

    // Busca um chat por uuid e adiciona no topo da lista (usado quando WS notifica chat fora da página carregada)
    const prependChatPorUuid = useCallback(async (chatUuid: string) => {
        const chat = await buscarChatPorUuid(chatUuid);
        if (!chat) return;

        const termo = pesquisaDebouncedRef.current.trim();
        if (termo) {
            const normalizar = (v: string) => v.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
            const termoNorm = normalizar(termo);
            const nome = normalizar(chat.contato?.nome ?? '');
            const tel = (chat.contato?.telefone ?? '').toLowerCase();
            const telDigitos = termo.replace(/\D/g, '');
            const casaNome = nome.includes(termoNorm);
            const casaTel = telDigitos ? tel.includes(telDigitos) : false;
            if (!casaNome && !casaTel) return;
        }

        setChats(prev => {
            if (prev.some(c => c.uuid === chat.uuid)) return prev;
            return [chat, ...prev];
        });
    }, [buscarChatPorUuid]);

    // Atualizar chat na lista (mover para o topo e atualizar última mensagem)
    // Usa refs para evitar dependências que causam re-registro de listeners
    const atualizarChatNaLista = useCallback((chatUuid: string, ultimaMensagem: IMensagem, contadorNotificacoes?: number, omitirContador?: boolean) => {
        try {
            setChats(prevChats => {
                const chatIndex = prevChats.findIndex(c => c.uuid === chatUuid);
                if (chatIndex === -1) {
                    // Chat fora da página carregada — buscar individualmente e dar prepend
                    setTimeout(() => prependChatPorUuid(chatUuid), 0);
                    return prevChats;
                }

                const chatAtual = prevChats[chatIndex];
                const chatAtualizado = {
                    ...chatAtual,
                    ultimaMensagem,
                    dataHoraUltimaAtualizacao: new Date().toISOString()
                };

                // omitirContador: usado para mensagens enviadas pelo atendente,
                // que nunca devem modificar o contador de notificações
                if (!omitirContador) {
                    // Usa ref para evitar dependência de chatSelecionado
                    // Se o chat não está selecionado, atualiza o contador
                    if (chatUuid !== chatSelecionadoRef.current) {
                        // Se recebeu contadorNotificacoes do evento, usar esse valor (sempre o mais atualizado)
                        if (contadorNotificacoes !== undefined && contadorNotificacoes !== null) {
                            chatAtualizado.contadorNotificacoes = contadorNotificacoes;
                        } else if (chatAtual.contadorNotificacoes !== undefined) {
                            // Se não recebeu contador no evento mas o chat já tem, incrementar
                            chatAtualizado.contadorNotificacoes = (chatAtual.contadorNotificacoes || 0) + 1;
                        } else {
                            // Primeira mensagem para esse chat
                            chatAtualizado.contadorNotificacoes = 1;
                        }
                    } else {
                        // Se o chat está selecionado, zera o contador (será marcado como lido)
                        chatAtualizado.contadorNotificacoes = 0;
                    }
                }

                const novosChats = [...prevChats];
                novosChats[chatIndex] = chatAtualizado;
                novosChats.sort((a, b) => new Date(b.dataHoraUltimaAtualizacao).getTime() - new Date(a.dataHoraUltimaAtualizacao).getTime());

                return novosChats;
            });
        } catch (error) {
            console.error('Erro ao atualizar chat na lista:', error);
            setTimeout(() => prependChatPorUuid(chatUuid), 0);
        }
    }, [prependChatPorUuid]);

    const adicionarMensagemNaSessao = useCallback((mensagem: IMensagem, sessaoUuid: string) => {
        setSessoes(prevSessoes => {
            const sessaoIndex = prevSessoes.findIndex(s => s.uuid === sessaoUuid);
            if (sessaoIndex === -1) {
                setTimeout(() => setSessoesRefreshTrigger(prev => prev + 1), 0);
                return prevSessoes;
            }

            const novasSessoes = [...prevSessoes];
            const mensagensAtuais = novasSessoes[sessaoIndex].mensagens || [];
            if (mensagensAtuais.some(m => m.uuid === mensagem.uuid)) {
                return prevSessoes;
            }
            const sessaoAtualizada = {
                ...novasSessoes[sessaoIndex],
                mensagens: [...mensagensAtuais, mensagem]
            };
            novasSessoes[sessaoIndex] = sessaoAtualizada;

            return novasSessoes;
        });
    }, []);

    const atualizarMensagemEditada = useCallback((mensagemUuid: string, identificadorExterno: string, novoTexto: string) => {
        setSessoes(prevSessoes =>
            prevSessoes.map(sessao => ({
                ...sessao,
                mensagens: sessao.mensagens?.map(mensagem =>
                    (mensagem.uuid === mensagemUuid || mensagem.identificadorExterno === identificadorExterno)
                        ? { ...mensagem, texto: novoTexto, editada: true }
                        : mensagem
                ) || []
            }))
        );
    }, []);

    const atualizarStatusMensagem = useCallback((messageIds: string[], status: IMensagem['status']) => {
        const ids = new Set(messageIds);
        setSessoes(prevSessoes =>
            prevSessoes.map(sessao => ({
                ...sessao,
                mensagens: sessao.mensagens?.map(mensagem =>
                    mensagem.identificadorExterno && ids.has(mensagem.identificadorExterno)
                        ? { ...mensagem, status }
                        : mensagem
                ) || []
            }))
        );
    }, []);

    useEffect(() => {
        if (sessoesRefreshTrigger > 0 && chatSelecionadoRef.current) {
            handleListarSessoes();
        }
    }, [sessoesRefreshTrigger]);

    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onNovaMensagemRecebida((data: IWebSocketNovaMensagemRecebida) => {
            try {
                // Atualizar lista de chats
                atualizarChatNaLista(data.chatUuid, {
                    uuid: data.mensagem.uuid,
                    identificadorExterno: data.mensagem.identificadorExterno,
                    emissor: data.mensagem.emissor,
                    log: data.mensagem.log,
                    tipo: data.mensagem.tipo,
                    texto: data.mensagem.texto,
                    audioUrl: data.mensagem.audioUrl,
                    imagemUrl: data.mensagem.imagemUrl,
                    videoUrl: data.mensagem.videoUrl,
                    dataHora: new Date(data.mensagem.dataHora).toISOString()
                }, data.contadorNotificacoes);

                // Se o chat está aberto quando a mensagem chega, o backend incrementou
                // o contador mesmo assim. Sincronizar com debounce para não sobrecarregar.
                if (chatSelecionadoRef.current === data.chatUuid) {
                    if (marcarLidoDebounceRef.current) {
                        clearTimeout(marcarLidoDebounceRef.current);
                    }
                    marcarLidoDebounceRef.current = setTimeout(() => {
                        marcarChatComoLido(data.chatUuid);
                    }, 800);
                }
            } catch (error) {
                console.error('Erro ao processar nova mensagem recebida:', error);
            }
        });

        return cleanup;
    }, [isConnected, onNovaMensagemRecebida, atualizarChatNaLista, marcarChatComoLido]);

    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onNovaMensagemEnviada((data: IWebSocketNovaMensagemEnviada) => {
            // Atualizar lista de chats — omitirContador=true pois mensagens enviadas
            // pelo atendente nunca devem modificar o contador de notificações
            atualizarChatNaLista(data.chatUuid, {
                uuid: data.mensagem.uuid,
                identificadorExterno: data.mensagem.identificadorExterno,
                emissor: data.mensagem.emissor,
                log: data.mensagem.log,
                tipo: data.mensagem.tipo,
                texto: data.mensagem.texto,
                audioUrl: data.mensagem.audioUrl,
                imagemUrl: data.mensagem.imagemUrl,
                videoUrl: data.mensagem.videoUrl,
                dataHora: new Date(data.mensagem.dataHora).toISOString()
            }, undefined, true);

            // Se o chat está aberto, adicionar mensagem na sessão
            if (chatSelecionadoRef.current === data.chatUuid && data.sessaoUuid) {
                adicionarMensagemNaSessao({
                    uuid: data.mensagem.uuid,
                    identificadorExterno: data.mensagem.identificadorExterno,
                    emissor: data.mensagem.emissor,
                    log: data.mensagem.log,
                    tipo: data.mensagem.tipo,
                    texto: data.mensagem.texto,
                    audioUrl: data.mensagem.audioUrl,
                    imagemUrl: data.mensagem.imagemUrl,
                    videoUrl: data.mensagem.videoUrl,
                    dataHora: new Date(data.mensagem.dataHora).toISOString(),
                    mensagemRespondida: data.mensagem.mensagemRespondida
                }, data.sessaoUuid);
            }
        });

        return cleanup;
    }, [isConnected, onNovaMensagemEnviada, atualizarChatNaLista, adicionarMensagemNaSessao]);

    // WebSocket: Nova mensagem no chat aberto
    // Este listener é registrado/desregistrado quando entra/sai de um chat específico
    useEffect(() => {
        if (!isConnected || !chatSelecionado) return;

        const cleanup = onNovaMensagem((data: IWebSocketNovaMensagem) => {
            // Adicionar mensagem na sessão
            adicionarMensagemNaSessao({
                uuid: data.mensagem.uuid,
                identificadorExterno: data.mensagem.identificadorExterno,
                emissor: data.mensagem.emissor,
                log: data.mensagem.log,
                tipo: data.mensagem.tipo,
                texto: data.mensagem.texto,
                audioUrl: data.mensagem.audioUrl,
                imagemUrl: data.mensagem.imagemUrl,
                videoUrl: data.mensagem.videoUrl,
                dataHora: new Date(data.mensagem.dataHora).toISOString(),
                mensagemRespondida: data.mensagem.mensagemRespondida
            }, data.sessaoUuid);
        });

        return cleanup;
    }, [isConnected, chatSelecionado, onNovaMensagem, adicionarMensagemNaSessao]);

    // Gerenciar entrar/sair de chat
    useEffect(() => {
        if (!isConnected) return;

        // Sair do chat anterior (se houver)
        if (chatSelecionadoAnterior) {
            sairChat(chatSelecionadoAnterior);
        }

        // Entrar no novo chat (se houver)
        if (chatSelecionado) {
            entrarChat(chatSelecionado);
            setChatSelecionadoAnterior(chatSelecionado);
        }

        // Cleanup: sair do chat ao desmontar
        return () => {
            if (chatSelecionado) {
                sairChat(chatSelecionado);
            }
        };
    }, [chatSelecionado, isConnected]);

    // Carrega/recarrega página 1 quando muda o termo de busca (e no mount, com termo vazio).
    // Também reseta o scroll do container para o topo, para não confundir o usuário com
    // posição de scroll antiga após troca de lista.
    useEffect(() => {
        handleListarChats(1, false);
        if (chatsContainerRef.current) {
            chatsContainerRef.current.scrollTop = 0;
        }
    }, [pesquisaDebounced])

    // IntersectionObserver dispara carregamento da próxima página ao chegar no fim da lista
    useEffect(() => {
        const sentinel = sentinelRef.current;
        const root = chatsContainerRef.current;
        if (!sentinel || !root || !temMaisChats || carregandoMais || loadingChats) return;
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                handleListarChats(pagina + 1, true);
            }
        }, { root, rootMargin: '200px' });
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [temMaisChats, carregandoMais, loadingChats, pagina, pesquisaDebounced])

    useEffect(() => {
        handleListarSessoes();
    }, [chatSelecionado])

    // Marcar chat como lido quando for aberto
    useEffect(() => {
        if (chatSelecionado && chatMarcadoComoLidoRef.current !== chatSelecionado) {
            // Marcar que este chat já foi marcado como lido para evitar loop
            chatMarcadoComoLidoRef.current = chatSelecionado;
            
            // Limpar contador imediatamente ao abrir (otimização visual)
            setChats(prevChats => 
                prevChats.map(chat => 
                    chat.uuid === chatSelecionado 
                        ? { ...chat, contadorNotificacoes: 0 }
                        : chat
                )
            );
            
            // Marcar como lido no backend
            marcarChatComoLido(chatSelecionado);
        }
        
        // Limpar a ref quando o chat selecionado mudar para um diferente
        if (!chatSelecionado) {
            chatMarcadoComoLidoRef.current = undefined;
        }
    }, [chatSelecionado]);

    // WebSocket: Chat marcado como lido
    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onChatLido((data: { chatUuid: string }) => {
            // Limpar contador de notificações do chat
            setChats(prevChats => 
                prevChats.map(chat => 
                    chat.uuid === data.chatUuid 
                        ? { ...chat, contadorNotificacoes: 0 }
                        : chat
                )
            );
        });

        return cleanup;
    }, [isConnected, onChatLido]);

    // WebSocket: Alerta criado em um chat
    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onAlertaChat((data: { chatUuid: string; alerta: any }) => {
            setChats(prevChats => {
                const chatIndex = prevChats.findIndex(c => c.uuid === data.chatUuid);
                if (chatIndex === -1) {
                    setTimeout(() => prependChatPorUuid(data.chatUuid), 0);
                    return prevChats;
                }

                const chatAtualizado = {
                    ...prevChats[chatIndex],
                    alerta: data.alerta,
                };

                const novosChats = [...prevChats];
                novosChats[chatIndex] = chatAtualizado;
                novosChats.sort((a, b) => new Date(b.dataHoraUltimaAtualizacao).getTime() - new Date(a.dataHoraUltimaAtualizacao).getTime());

                return novosChats;
            });
        });

        return cleanup;
    }, [isConnected, onAlertaChat, prependChatPorUuid]);

    // WebSocket: Alerta removido de um chat
    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onAlertaChatRemovido((data: { chatUuid: string }) => {
            setChats(prevChats => {
                const chatIndex = prevChats.findIndex(c => c.uuid === data.chatUuid);
                if (chatIndex === -1) return prevChats;

                const chatAtualizado = {
                    ...prevChats[chatIndex],
                    alerta: undefined,
                };

                const novosChats = [...prevChats];
                novosChats[chatIndex] = chatAtualizado;
                novosChats.sort((a, b) => new Date(b.dataHoraUltimaAtualizacao).getTime() - new Date(a.dataHoraUltimaAtualizacao).getTime());

                return novosChats;
            });
        });

        return cleanup;
    }, [isConnected, onAlertaChatRemovido]);

    // WebSocket: Status do pedido atualizado em um chat
    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onStatusPedidoChat((data) => {
            setChats(prev => prev.map(c =>
                c.uuid === data.chatUuid
                    ? { ...c, pedidoAtivo: data.status ? { pedidoUuid: data.pedidoUuid as string, status: data.status, pagamentos: data.pagamentos ?? [] } : undefined }
                    : c
            ));
        });

        return cleanup;
    }, [isConnected, onStatusPedidoChat]);

    // WebSocket: Status de entrega/leitura de mensagem atualizado
    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onStatusMensagem((data) => {
            atualizarStatusMensagem(data.messageIds, data.status);
        });

        return cleanup;
    }, [isConnected, onStatusMensagem, atualizarStatusMensagem]);

    // WebSocket: Mensagem editada pelo cliente
    useEffect(() => {
        if (!isConnected) return;

        const cleanup = onMensagemEditada((data) => {
            atualizarMensagemEditada(data.mensagemUuid, data.identificadorExterno, data.novoTexto);
        });

        return cleanup;
    }, [isConnected, onMensagemEditada, atualizarMensagemEditada]);

    const fimDasMensagensRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (fimDasMensagensRef.current) {
            fimDasMensagensRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [sessoes]);

    // Polling HTTP como fallback quando WebSocket está desconectado
    const pollingIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const pollFnRef = useRef<() => Promise<void>>();

    pollFnRef.current = async () => {
        try {
            const buscaAtual = pesquisaDebouncedRef.current.trim() || undefined;
            const chatsEncontrados: IChatMensagens[] | null = await listarChats(1, LIMITE_POR_PAGINA, buscaAtual);
            if (chatsEncontrados !== null) {
                const lista = chatsEncontrados ?? [];
                setChats(lista);
                setPagina(1);
                setTemMaisChats(lista.length === LIMITE_POR_PAGINA);
            }
            if (chatSelecionadoRef.current) {
                const sessoesEncontradas: ISessaoMensagens[] = await listarSessoes(chatSelecionadoRef.current, 1, 10);
                if (sessoesEncontradas?.length) {
                    setSessoes(sessoesEncontradas);
                }
            }
        } catch {
            // Polling silencioso
        }
    };

    useEffect(() => {
        if (isConnected) {
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
                pollingIntervalRef.current = null;
            }
            return;
        }

        // Aguardar 8s antes de iniciar polling (dar tempo ao WS reconectar)
        const delayTimer = setTimeout(() => {
            // Executar imediatamente ao começar e depois a cada 60s
            pollFnRef.current?.();
            pollingIntervalRef.current = setInterval(() => {
                pollFnRef.current?.();
            }, 60000);
        }, 8000);

        return () => {
            clearTimeout(delayTimer);
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
                pollingIntervalRef.current = null;
            }
        };
    }, [isConnected]);



    // Propagar dados do contato do chat para o contexto do ChatPdV
    useEffect(() => {
        if (chatSelecionado && chats.length > 0 && chatProcessadoRef.current !== chatSelecionado) {
            const chat = chats.find(c => c.uuid === chatSelecionado);
            if (chat) {
                chatProcessadoRef.current = chatSelecionado;
                definirContatoChat(chat.contato, chat.uuid, chat.clienteUuid);
            } else {
                chatProcessadoRef.current = undefined;
            }
        }
    }, [chatSelecionado, chats, definirContatoChat]);

    const chatAtivo = chats?.find(chat => chat.uuid == chatSelecionado);
    const marketplaceAtivo = marketplaces?.find(mp => mp.uuid === chatAtivo?.marketplaceUuid);
    const mensagensRapidas = (marketplaceAtivo?.configuracao?.integracao as IIntegracaoWhatsApp)?.mensagensRapidas ?? [];

    // ===== Multi-operador: filtro de chats por aba =====
    const multiOperador = operadores.length >= 2;

    // Se a aba ativa for de um operador que desconectou, volta para TODOS
    useEffect(() => {
        if (abaAtiva !== 'TODOS' && !operadores.some(op => op.operadorUuid === abaAtiva)) {
            setAbaAtiva('TODOS');
        }
    }, [operadores, abaAtiva]);

    const chatsFiltrados = !multiOperador
        ? chats
        : abaAtiva === 'TODOS'
            ? chats.filter(c => !atribuicoes.has(c.uuid))
            : chats.filter(c => atribuicoes.get(c.uuid)?.operadorUuid === abaAtiva);

    const contagensAbas = chats.reduce<Record<string, number>>((acc, c) => {
        const dono = atribuicoes.get(c.uuid)?.operadorUuid;
        const chave = dono ?? 'TODOS';
        acc[chave] = (acc[chave] ?? 0) + 1;
        return acc;
    }, {});

    const atribuicaoChatAtivo = chatAtivo ? atribuicoes.get(chatAtivo.uuid) : undefined;

    // Quem falou por último na conversa aberta. As sessões são a fonte mais
    // atual: mensagem que chega no chat aberto entra nelas, e não
    // necessariamente no `ultimaMensagem` do item da lista.
    const emissorUltimaMensagemChatAtivo = useMemo(() => {
        const mensagens = (sessoes ?? [])
            .flatMap(sessao => sessao.mensagens ?? [])
            .filter(mensagem => mensagem.emissor !== TipoEmissorMensagem.SISTEMA);

        if (!mensagens.length) return chatAtivo?.ultimaMensagem?.emissor;

        return mensagens.reduce((maisRecente, mensagem) =>
            new Date(mensagem.dataHora).getTime() > new Date(maisRecente.dataHora).getTime()
                ? mensagem
                : maisRecente
        ).emissor;
    }, [sessoes, chatAtivo?.ultimaMensagem?.emissor]);

    // O alerta amarelo continua; o "precisa de você" só vale enquanto ninguém da
    // loja respondeu depois do cliente.
    const chatAtivoPrecisaResposta = precisaResponder(emissorUltimaMensagemChatAtivo);
    const pendentesAtencao = chats.filter(chat =>
        !!chat.alerta && precisaResponder(
            chat.uuid === chatSelecionado ? emissorUltimaMensagemChatAtivo : chat.ultimaMensagem?.emissor
        )
    ).length;
    const estadoChatAtivo = ESTADO_ATENDIMENTO[
        estadoDaConversa(!!chatAtivo?.alerta, !!atribuicaoChatAtivo, chatAtivoPrecisaResposta)
    ];

    const mostrarLoading = loadingChats || loadingCliente || loadingPedidosEmAndamento || loadingExclusao;

    return (
        <>
            {estaBloqueado && motivoExibir && (
                <ChatAbaUnicaOverlay motivo={motivoExibir} onAssumirControle={handleAssumirControle} />
            )}
            {mostrarLoading && <FullScreenLoading />}
            <PageContainer>
            <ChatsContainer ref={chatsContainerRef} variant="outlined">
                <PesquisarContainer>
                    <CaixaBusca component="form" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
                        <Search sx={{ fontSize: 17, color: 'text.secondary' }} />
                        <InputBase
                            sx={{ flex: 1, ...texto.corpo }}
                            placeholder="Buscar nome ou telefone"
                            inputProps={{ 'aria-label': 'pesquisar' }}
                            size="small"
                            onChange={(e) => setPesquisa(e.target.value)}
                            value={pesquisa}
                        />
                        {!!pesquisa && (
                            <IconButton size="small" aria-label="limpar busca" onClick={() => setPesquisa('')}>
                                <Close sx={{ fontSize: 14 }} />
                            </IconButton>
                        )}
                    </CaixaBusca>

                    {/* Quantas conversas a IA marcou: é a primeira informação que o operador precisa. */}
                    {pendentesAtencao > 0 && (
                        <Box
                            sx={{
                                alignSelf: 'flex-start',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.75,
                                px: 1.1,
                                py: 0.5,
                                borderRadius: raio.pill,
                                backgroundColor: alpha(cores.alerta[500], 0.14),
                                border: `1px solid ${alpha(cores.alerta[500], 0.35)}`,
                            }}
                        >
                            <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cores.alerta[500] }} />
                            <Typography sx={{ ...texto.etiqueta, color: theme => textoAlertaForte(theme) }}>
                                {pendentesAtencao} {pendentesAtencao === 1 ? 'precisa' : 'precisam'} de você
                            </Typography>
                        </Box>
                    )}
                </PesquisarContainer>

                {/* Indicador de status da conexão WebSocket */}
                {!isConnected && (
                    <Box sx={{ px: 1.5, pt: 0.5, pb: 0.25, width: '100%' }}>
                        {isConnecting ? (
                            <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
                                    <SyncProblem sx={{ fontSize: '0.85rem', color: 'warning.main' }} />
                                    <Typography variant="caption" sx={{ color: 'warning.main', fontWeight: 500 }}>
                                        Reconectando{reconnectionAttempt > 0 ? ` (tentativa ${reconnectionAttempt})` : ''}...
                                    </Typography>
                                </Box>
                                <LinearProgress color="warning" sx={{ borderRadius: 1, height: 3 }} />
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                                <WifiOff sx={{ fontSize: '0.85rem', color: 'error.main' }} />
                                <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 500 }}>
                                    Sem conexão — atualizando a cada 1 min
                                </Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {multiOperador && (
                    <AbasOperadores
                        operadores={operadores}
                        operadorUuidAtual={operadorUuidAtual}
                        abaAtiva={abaAtiva}
                        onChange={setAbaAtiva}
                        contagens={contagensAbas}
                    />
                )}

                <Box sx={{ display: 'flex', alignItems: 'center', px: 1.5, pb: 0.5, gap: 1, width: '100%', minHeight: 32 }}>
                    {!modoSelecao ? (
                        <Button size="small" onClick={handleToggleModoSelecao} sx={{ fontSize: '0.72rem', textTransform: 'none', color: 'text.secondary' }}>
                            Selecionar
                        </Button>
                    ) : (
                        <>
                            <Button size="small" onClick={handleSelecionarTodos} sx={{ fontSize: '0.72rem', textTransform: 'none' }}>
                                {chatsSelecionados.size === chats.length && chats.length > 0 ? 'Desmarcar todos' : 'Selecionar todos'}
                            </Button>
                            <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                                {chatsSelecionados.size > 0 && (
                                    <Tooltip title={isConnected ? `Assumir ${chatsSelecionados.size} conversa${chatsSelecionados.size > 1 ? 's' : ''}` : 'Sem conexão para assumir'}>
                                        <span>
                                            <Paper
                                                onClick={isConnected ? handleAssumirSelecionados : undefined}
                                                elevation={1}
                                                sx={{
                                                    width: 20,
                                                    height: 20,
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: isConnected ? 'pointer' : 'not-allowed',
                                                    opacity: isConnected ? 1 : 0.4,
                                                    bgcolor: 'success.main',
                                                    color: 'white',
                                                    transition: 'all 0.2s',
                                                    '&:hover': isConnected ? { boxShadow: 3, transform: 'translateY(-2px)' } : undefined,
                                                    '& svg': { width: 12, height: 12 }
                                                }}
                                            >
                                                <PersonAddAlt1 />
                                            </Paper>
                                        </span>
                                    </Tooltip>
                                )}
                                {chatsSelecionados.size > 0 && (
                                    <Tooltip title={`Excluir ${chatsSelecionados.size} conversa${chatsSelecionados.size > 1 ? 's' : ''}`}>
                                        <Paper
                                            onClick={handleExcluirSelecionados}
                                            elevation={1}
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                bgcolor: 'error.main',
                                                color: 'white',
                                                transition: 'all 0.2s',
                                                '&:hover': { boxShadow: 3, transform: 'translateY(-2px)' },
                                                '& svg': { width: 12, height: 12 }
                                            }}
                                        >
                                            <Delete />
                                        </Paper>
                                    </Tooltip>
                                )}
                                <Button
                                    size="small"
                                    onClick={handleToggleModoSelecao}
                                    sx={{ fontSize: '0.72rem', textTransform: 'none', color: 'text.secondary' }}
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
                {chatsFiltrados.map((chat: IChatMensagens) => {
                    const isAlerta = chat.alerta ? true : false;
                    const isSelecionado = chatSelecionado == chat.uuid;

                    // Estado da conversa no mesmo código visual do site: alerta da IA
                    // vence atribuição, porque é o que precisa de ação — mas só
                    // enquanto a resposta ainda não saiu.
                    const atribuicao = atribuicoes.get(chat.uuid);
                    const aguardandoResposta = precisaResponder(
                        isSelecionado ? emissorUltimaMensagemChatAtivo : chat.ultimaMensagem?.emissor
                    );
                    const estado = estadoDaConversa(isAlerta, !!atribuicao, aguardandoResposta);
                    const meta = ESTADO_ATENDIMENTO[estado];
                    const IconeEstado = meta.icone;
                    const rotuloEstado = estado === 'operador' && atribuicao
                        ? `${meta.rotulo} · ${atribuicao.nome}`
                        : meta.rotulo;

                    return (
                        <CardChat
                            key={chat.uuid}
                            alerta={isAlerta}
                            selecionado={isSelecionado}
                            onMouseEnter={() => setHoveredChat(chat.uuid)}
                            onMouseLeave={() => {
                                // Só limpa o hover se o menu não estiver aberto para este chat
                                if (!menuAnchorEl || menuAnchorEl.chatUuid !== chat.uuid) {
                                    setHoveredChat(null);
                                }
                            }}
                            sx={{
                                // Faixa lateral: acesa no chat aberto e em tudo que a IA marcou.
                                '&::before': {
                                    backgroundColor: isSelecionado || isAlerta ? meta.cor : 'transparent',
                                },
                            }}
                        >
                            <CardActionAreaChat onClick={() => modoSelecao ? handleToggleChatSelecionado(chat.uuid) : handleChat(chat.uuid)}>
                                {modoSelecao && (
                                    <Checkbox
                                        size="small"
                                        checked={chatsSelecionados.has(chat.uuid)}
                                        onChange={() => handleToggleChatSelecionado(chat.uuid)}
                                        onClick={(e) => e.stopPropagation()}
                                        sx={{ p: 0.5, mr: -0.5, flexShrink: 0 }}
                                    />
                                )}
                                <Badge
                                    badgeContent={chat.contadorNotificacoes && chat.contadorNotificacoes > 0 ? chat.contadorNotificacoes : 0}
                                    color="error"
                                    max={99}
                                    invisible={!chat.contadorNotificacoes || chat.contadorNotificacoes === 0}
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            fontSize: '0.7rem',
                                            height: '18px',
                                            minWidth: '18px',
                                            padding: '0 4px'
                                        }
                                    }}
                                >
                                    <Avatar
                                        alt={chat.contato?.nome}
                                        src={chat.contato?.foto || undefined}
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            fontSize: '0.85rem',
                                            fontWeight: 700,
                                            color: 'text.primary',
                                            backgroundColor: alpha(meta.cor, 0.16),
                                            border: `1px solid ${alpha(meta.cor, 0.32)}`,
                                        }}
                                    >
                                        {chat.contato?.nome?.charAt(0)?.toUpperCase()}
                                    </Avatar>
                                </Badge>
                                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.25, minWidth: 0 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                        <Typography sx={{ ...texto.titulo, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {chat.contato?.nome}
                                        </Typography>
                                        <Typography sx={{ ...texto.apoio, color: 'text.secondary', flexShrink: 0, ml: 1 }}>
                                            {dataHoraOuHora(chat.dataHoraUltimaAtualizacao)}
                                        </Typography>
                                    </Box>
                                    {chat?.ultimaMensagem && (
                                        <Typography
                                            sx={{
                                                ...texto.corpo,
                                                color: 'text.secondary',
                                                width: '100%',
                                                mt: 0.25,
                                                ...limitarLinhas(1),
                                            }}
                                        >
                                            {chat.ultimaMensagem?.texto}
                                        </Typography>
                                    )}
                                    {/* Estado do atendimento: só quando diz algo. Conversa que a IA
                                        está tocando é o caso normal e não precisa de etiqueta; alerta
                                        já respondido também não — fica só o amarelo. */}
                                    {!!meta.rotulo && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, mt: 0.75, maxWidth: '100%' }}>
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                display: 'grid',
                                                placeItems: 'center',
                                                flexShrink: 0,
                                                backgroundColor: alpha(meta.cor, 0.15),
                                                color: meta.cor,
                                                ...(estado === 'atencao' ? pulsoAtencao : {}),
                                            }}
                                        >
                                            <IconeEstado sx={{ fontSize: 11 }} />
                                        </Box>
                                        <Typography
                                            sx={{
                                                ...texto.etiqueta,
                                                color: meta.cor,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {rotuloEstado}
                                        </Typography>
                                    </Box>
                                    )}
                                    {chat.pedidoAtivo && (() => {
                                        const pedido = chat.pedidoAtivo;
                                        const corStatus = (StatusPedidosCores as Record<string, string>)[pedido.status] ?? '#999';
                                        const pagamentos = pedido.pagamentos ?? [];
                                        const metodo = pagamentos[0]?.metodoPagamento;
                                        const IconPagamento = metodo === MetodoPagamento.Pix
                                            ? Pix
                                            : metodo === MetodoPagamento.Dinheiro
                                                ? Payments
                                                : CreditCard;

                                        return (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    width: '100%',
                                                    gap: 0.75,
                                                    mt: 0.6,
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                                    <Box sx={{ width: 7, height: 7, borderRadius: '50%', flexShrink: 0, bgcolor: corStatus }} />
                                                    <Typography
                                                        sx={{
                                                            ...texto.apoio,
                                                            fontWeight: 600,
                                                            color: corStatus,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {pedido.status}
                                                    </Typography>
                                                </Box>
                                                {!!pagamentos.length && (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4, flexShrink: 0, maxWidth: '55%', overflow: 'hidden', color: 'text.secondary' }}>
                                                        <IconPagamento sx={{ fontSize: 13, flexShrink: 0 }} />
                                                        <Typography sx={{ ...texto.apoio, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {pagamentos.length === 1 ? metodo ?? '—' : `${pagamentos.length}+`}
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        );
                                    })()}
                                </Box>
                            </CardActionAreaChat>
                            {!modoSelecao && (hoveredChat === chat.uuid || (menuAnchorEl && menuAnchorEl.chatUuid === chat.uuid)) && (
                                <IconButton
                                    size="small"
                                    onClick={(e) => handleOpenMenu(e, chat.uuid)}
                                    sx={{ 
                                        position: 'absolute',
                                        bottom: 6,
                                        right: 6,
                                        zIndex: 10,
                                        padding: '4px',
                                        backgroundColor: theme => superficie(theme, 0.09),
                                        '&:hover': {
                                            backgroundColor: theme => superficie(theme, 0.16),
                                        }
                                    }}
                                >
                                    <KeyboardArrowDown fontSize="small" />
                                </IconButton>
                            )}
                        </CardChat>
                    );
                })}
                {temMaisChats && <div ref={sentinelRef} style={{ width: '100%', height: 1 }} />}
                {carregandoMais && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1, width: '100%' }}>
                        <CircularProgress size={20} />
                    </Box>
                )}
                {!loadingChats && chats.length === 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3, px: 2, width: '100%' }}>
                        <Typography variant="body2" color="textSecondary" align="center">
                            {pesquisaDebounced ? 'Nenhuma conversa encontrada' : 'Nenhuma conversa'}
                        </Typography>
                    </Box>
                )}
                <Menu
                    anchorEl={menuAnchorEl?.element}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleCloseMenu}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    sx={{ zIndex: 9999 }}
                    slotProps={{
                        paper: {
                            sx: {
                                boxShadow: 3
                            }
                        }
                    }}
                >
                    <MenuItem onClick={handleExcluirChat} sx={{ gap: 1 }}>
                        <ListItemIcon sx={{ minWidth: 'auto' }}>
                            <Delete fontSize="small" color="error" />
                        </ListItemIcon>
                        <Typography variant="inherit">Excluir conversa</Typography>
                    </MenuItem>
                </Menu>
            </ChatsContainer>
            <MensagensContainer>
                {chatAtivo ? (
                    <>
                        <MensagensHeaderContainer elevation={0}>
                            <MensagensContatoContainer>
                                <Avatar
                                    alt={chatAtivo.contato?.nome}
                                    src={chatAtivo.contato?.foto || undefined}
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        fontSize: '0.9rem',
                                        fontWeight: 700,
                                        color: 'text.primary',
                                        backgroundColor: theme => alpha(estadoChatAtivo.cor, theme.palette.mode === 'dark' ? 0.2 : 0.16),
                                        border: `1px solid ${alpha(estadoChatAtivo.cor, 0.32)}`,
                                    }}
                                >
                                    {chatAtivo.contato?.nome?.charAt(0)?.toUpperCase()}
                                </Avatar>
                                <DadosContatoContainer>
                                    <Typography sx={{ ...texto.titulo, fontSize: '14px', ...limitarLinhas(1) }}>
                                        {chatAtivo.contato?.nome}
                                    </Typography>
                                    <Typography sx={{ ...texto.apoio, color: 'text.secondary' }}>
                                        WhatsApp · {chatAtivo.contato?.telefone}
                                    </Typography>
                                </DadosContatoContainer>
                            </MensagensContatoContainer>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {multiOperador && (
                                    <BarraAtribuicaoChat
                                        atribuicao={atribuicaoChatAtivo}
                                        operadorUuidAtual={operadorUuidAtual}
                                        onAssumir={() => assumirChat(chatAtivo.uuid)}
                                        onLiberar={() => liberarChat(chatAtivo.uuid)}
                                    />
                                )}
                                {checkoutComoDrawer && (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<ShoppingCartCheckout />}
                                        onClick={() => setDrawerCheckoutAberto(true)}
                                        sx={{ px: 3, py: 1 }}
                                    >
                                        Checkout
                                    </Button>
                                )}
                            </Box>
                        </MensagensHeaderContainer>
                        <SessaoMensagensContainer>
                    {(() => {
                        const mensagensRenderizadas = [...(sessoes ?? [])]
                            .sort((a, b) => new Date(a.dataHoraInicio).getTime() - new Date(b.dataHoraInicio).getTime())
                            .flatMap(sessao =>
                                [...(sessao.mensagens ?? [])]
                                    .filter(mensagem => mensagem.emissor !== TipoEmissorMensagem.SISTEMA)
                                    .sort((a, b) => new Date(a.dataHora).getTime() - new Date(b.dataHora).getTime())
                                    .map((mensagem, index) => {
                                        const position = [TipoEmissorMensagem.ATENDENTE, TipoEmissorMensagem.ATENDENTE_IA].includes(mensagem.emissor)
                                            ? "right"
                                            : "left";
                                        const timestamp = dataHoraOuHora(mensagem.dataHora);

                                        if (mensagem.tipo === 'AUDIO' && mensagem.audioUrl) {
                                            return (
                                                <AudioBubble
                                                    key={`${mensagem.uuid}-${index}`}
                                                    audioUrl={mensagem.audioUrl}
                                                    timestamp={timestamp}
                                                    position={position}
                                                />
                                            );
                                        }

                                        if (mensagem.tipo === 'IMAGEM' && mensagem.imagemUrl) {
                                            return (
                                                <ImagemBubble
                                                    key={`${mensagem.uuid}-${index}`}
                                                    imagemUrl={mensagem.imagemUrl}
                                                    caption={mensagem.texto}
                                                    timestamp={timestamp}
                                                    position={position}
                                                />
                                            );
                                        }

                                        if (mensagem.tipo === 'VIDEO' && mensagem.videoUrl) {
                                            return (
                                                <VideoBubble
                                                    key={`${mensagem.uuid}-${index}`}
                                                    videoUrl={mensagem.videoUrl}
                                                    caption={mensagem.texto}
                                                    timestamp={timestamp}
                                                    position={position}
                                                />
                                            );
                                        }

                                        const texto = mensagem.texto || "Tipo de mensagem não suportado";
                                        return (
                                            <ChatBubble
                                                key={`${mensagem.uuid}-${index}`}
                                                text={texto}
                                                timestamp={timestamp}
                                                position={position}
                                                status={mensagem.status}
                                                editada={mensagem.editada}
                                                mensagemRespondida={mensagem.mensagemRespondida}
                                                onReply={() => setMensagemParaResponder({
                                                    identificadorExterno: mensagem.identificadorExterno,
                                                    texto: mensagem.texto,
                                                    emissor: mensagem.emissor,
                                                })}
                                            />
                                        );
                                    })
                            );
                        
                        if (mensagensRenderizadas.length === 0 && chatSelecionado) {
                            return (
                                <Box 
                                    display="flex" 
                                    justifyContent="center" 
                                    alignItems="center" 
                                    height="100%"
                                >
                                    <Typography variant="body1" color="textSecondary">
                                        Nenhuma mensagem encontrada
                                    </Typography>
                                </Box>
                            );
                        }
                        
                        return mensagensRenderizadas;
                    })()}
                    <div ref={fimDasMensagensRef} />

                </SessaoMensagensContainer>
                
                {(!chatAtivo?.alerta || chatAtivo?.alerta?.tipo === "PEDIDO_MANUAL" || chatAtivo?.alerta?.tipo === "ERRO_IA") && (
                    <Box sx={{ width: '100%', flexShrink: 0 }}>
                        <MessageInput
                            key={chatSelecionado}
                            chatUuid={chatSelecionado}
                            onSendMessage={handleEnviarMensagem}
                            loading={loadingEnvio}
                            disabled={false}
                            mensagensRapidas={mensagensRapidas}
                            replyTo={mensagemParaResponder ?? undefined}
                            onCancelReply={() => setMensagemParaResponder(null)}
                        />
                    </Box>
                )}
                
                {chatAtivo?.alerta && (
                    <Box
                        sx={{
                            width: '100%',
                            flexShrink: 0,
                            px: 2,
                            py: 1.75,
                            display: 'flex',
                            gap: 1.5,
                            alignItems: 'flex-start',
                            backgroundColor: theme => alpha(cores.alerta[500], theme.palette.mode === 'dark' ? 0.14 : 0.1),
                            borderTop: `1px solid ${alpha(cores.alerta[500], 0.35)}`,
                        }}
                    >
                        <SmartToy sx={{ fontSize: 18, color: cores.alerta[500], mt: '1px', flexShrink: 0 }} />
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ ...texto.titulo, color: theme => textoAlertaForte(theme) }}>
                                {chatAtivo.alerta.tipo === "ERRO_IA"
                                    ? "Falha na resposta com IA · Atendimento manual necessário"
                                    : `A IA marcou esta conversa · ${chatAtivo.alerta.tipo === "LIMITE_IA"
                                        ? "Limite de IA atingido"
                                        : chatAtivo.alerta.tipo === "RESERVA"
                                            ? "Solicitação de reserva"
                                            : chatAtivo.alerta.tipo === "PEDIDO_MANUAL"
                                                ? "Pedido manual"
                                                : "Atendimento manual necessário"}`}
                            </Typography>

                            <Typography sx={{ ...texto.corpo, color: theme => textoAlerta(theme), mt: 0.5, lineHeight: 1.5 }}>
                                {chatAtivo.alerta.motivo}
                            </Typography>

                            {chatAtivo.alerta.tipo !== "PEDIDO_MANUAL" && (
                                <Typography sx={{ ...texto.apoio, color: theme => textoAlerta(theme), mt: 0.75, lineHeight: 1.6 }}>
                                    {chatAtivoPrecisaResposta
                                        ? "Responda o cliente pelo WhatsApp para concluir o atendimento e remova o alerta depois de resolver — só então o robô volta a responder."
                                        : "O cliente já foi respondido. Remova o alerta quando o atendimento estiver resolvido — só então o robô volta a responder."}
                                </Typography>
                            )}
                        </Box>

                        {chatAtivo.alerta.tipo !== "PEDIDO_MANUAL" && (
                            <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                                {loadingAlerta ? (
                                    <CircularProgress size={22} sx={{ color: cores.alerta[500] }} />
                                ) : (
                                    <Button
                                        variant="contained"
                                        onClick={() => handleRemoverAlerta(chatAtivo.uuid)}
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '11.5px',
                                            fontWeight: 700,
                                            borderRadius: raio.sm,
                                            px: 1.75,
                                            py: 0.85,
                                            boxShadow: 'none',
                                            backgroundColor: cores.alerta[500],
                                            color: '#3A2600',
                                            '&:hover': { backgroundColor: cores.alerta[400], boxShadow: 'none' },
                                        }}
                                    >
                                        Remover alerta
                                    </Button>
                                )}
                            </Box>
                        )}
                    </Box>
                )}
                    </>
                ) : (
                    <Box 
                        display="flex" 
                        justifyContent="center" 
                        alignItems="center" 
                        height="80vh" 
                        width="100%"
                    >
                        <Typography variant="body1" color="textSecondary">
                            Selecione uma conversa para visualizar
                        </Typography>
                    </Box>
                )}
            </MensagensContainer>
            {!checkoutComoDrawer && <ChatPdVSidebar />}
            <Drawer
                anchor="right"
                open={drawerCheckoutAberto}
                onClose={() => setDrawerCheckoutAberto(false)}
                sx={{ zIndex: 10000 }}
                PaperProps={{
                    sx: {
                        width: 350,
                        maxWidth: '100vw',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }
                }}
            >
                <ChatPdVSidebar isDrawer />
            </Drawer>
        </PageContainer>
        </>
    );
}

export const ConversasAtendimento = () => {
    return (
        <ChatPdVProvider>
            <ConversasAtendimentoContent />
        </ChatPdVProvider>
    );
}